import React from 'react'

const Footer = () => {
  const socialLinks = [
    {
      icon: 'fab fa-telegram',
      url: 'https://t.me/somayeham1360',
      label: 'تلگرام'
    },
    {
      icon: 'fab fa-whatsapp',
      url: 'https://wa.me/09118699453',
      label: 'واتساپ'
    },
    {
      icon: 'fab fa-instagram',
      url: 'https://instagram.com/somayeharbabmojeni',
      label: 'اینستاگرام'
    }
  ]

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-text">
            <p>&copy; طراحی و توسعه توسط <a href="https://savitar.ir" target="_blank" rel="noopener noreferrer">ساویتار</a></p>
          </div>
          <div className="footer-social">
            {socialLinks.map((social, index) => (
              <a 
                key={index}
                href={social.url} 
                className="social-link" 
                target="_blank" 
                rel="noopener" 
                aria-label={social.label}
              >
                <i className={social.icon} aria-hidden="true"></i>
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer 